// ===== Module features for easy import in ClientContainer=====

import LossesAnalyticsModule from './LossesAnalytics';

const LossesModule = {
  ...LossesAnalyticsModule,
};

export default LossesModule;
